import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./stepper.css";
import { GoListOrdered } from "react-icons/go";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import weightLoss from "../assets/formicons/wightloss.png";
import balancedWeight from "../assets/formicons/balancedWeight2.png";
import muscle from "../assets/formicons/muscle (2).png";
import male from "../assets/formicons/male.png";
import female from "../assets/formicons/female.png";
import sport from "../assets/formicons/sport.png";
import veg from "../assets/formicons/veg.png";
import nonveg from "../assets/formicons/nonveg.png";
import vegan from "../assets/formicons/vegan.png";
import active from "../assets/formicons/physicallyactive.png";
import modarate from "../assets/formicons/modarate.png";
import sadentry from "../assets/formicons/sedentary.png";
import others from "../assets/formicons/others.png";
import breakfast from "../assets/formicons/breakfast.png";
import lunch from "../assets/formicons/lunch.png";
import dinner from "../assets/formicons/dinner.png";
import egg from "../assets/formicons/egg.png";
import highProtien from "../assets/formicons/highprotien.png";
import lowcrab from "../assets/formicons/crab.png";
import salads from "../assets/formicons/salads.png";
import ketogenic from "../assets/formicons/ketogenic.png";
import balancedfood from "../assets/formicons/balancedmeal.png";
import asthetic from "../assets/formicons/asthetic.png";
import weekly from "../assets/formicons/weekly.png";
import monthly from "../assets/formicons/Monthly.png";
import { useSelector } from "react-redux";

// steps
// import physicalinfo from "../assets/formicons/physicalinfo.png"
// import personalinfo from "../assets/formicons/personalinfo.png"
// import goal from "../assets/formicons/goal.png"
// import diet  from "../assets/formicons/diet.png"
// import foodPreference  from "../assets/formicons/foodprefrence.png"
// import physicaState  from "../assets/formicons/physicalstate.png"
// import plan  from "../assets/formicons/physicalstate.png"

const MultiStepForm = () => {
  const [step, setStep] = useState(1);
  const [complete, setComplete] = useState(false);
  const [formbtntext, setformBtntext] = useState("Checkout");
  let totalPrice = 0;

  const navigate = useNavigate();

  const steps = [
    "Personal Info",
    "Physical Info",
    "Goals",
    "Diet",
    "Food Preferences",
    "Physical State",
    "plan",
  ];

  const stepIcons = [
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-user"
    >
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-list-check"
    >
      <path d="M11 18H3" />
      <path d="m15 18 2 2 4-4" />
      <path d="M16 12H3" />
      <path d="M16 6H3" />
    </svg>,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-target"
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </svg>,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-dumbbell"
    >
      <path d="M14.4 14.4 9.6 9.6" />
      <path d="M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z" />
      <path d="m21.5 21.5-1.4-1.4" />
      <path d="M3.9 3.9 2.5 2.5" />
      <path d="M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z" />
    </svg>,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-dumbbell"
    >
      <path d="M14.4 14.4 9.6 9.6" />
      <path d="M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z" />
      <path d="m21.5 21.5-1.4-1.4" />
      <path d="M3.9 3.9 2.5 2.5" />
      <path d="M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z" />
    </svg>,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-milk"
    >
      <path d="M8 2h8" />
      <path d="M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2" />
      <path d="M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0" />
    </svg>,
    <GoListOrdered />,
  ];

  const validationSchemas = [
    Yup.object({
      fullName: Yup.string().required("Full Name is required"),
      phoneNumber: Yup.string().required("Phone Number is required"),
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      age: Yup.number().required("Age is required").positive().integer(),
    }),
    Yup.object({
      gender: Yup.string().required("Gender is required"),
      height: Yup.number().required("Height is required"),
      weight: Yup.number().required("Weight is required"),
    }),
    Yup.object({
      goal: Yup.string().required("Goal is required"),
    }),
    Yup.object({
      diet: Yup.string().required("Physical State is required"),
    }),
    Yup.object({
      foodPreference: Yup.string().required("Diet is required"),
    }),
    Yup.object({
      physicalState: Yup.string().required("Food Preference is required"),
      subscriptionType: Yup.string().required("Subscription type  is required"),
    }),
    Yup.object({
      plan: Yup.lazy((value) =>
        Array.isArray(value)
          ? Yup.array()
              .of(Yup.string())
              .min(1, "At least one plan must be selected")
              .required("Plan is required")
          : Yup.string().required("Plan is required")
      ),
      subscriptionStartDate: Yup.date()
        .required("Subscription start date is required")
        .min(
          new Date(new Date().setDate(new Date().getDate() + 2)),
          "Date cannot be today or the next two days."
        ), // Blocks today's date and the next two days
    }),
  ];

  const nextStep = async (validateForm, setTouched) => {
    const errors = await validateForm();
    const relevantFields = {
      1: ["fullName", "phoneNumber", "email", "age"],
      2: ["gender", "height", "weight"],
      3: ["goal"],
      4: ["diet"],
      5: ["foodPreference"],
      6: ["physicalState", "subscriptionType"],
      7: ["plan", "subscriptionStartDate"],
    };

    const currentErrors = relevantFields[step].reduce((acc, field) => {
      if (errors[field]) acc[field] = errors[field];
      return acc;
    }, {});

    if (Object.keys(currentErrors).length === 0) {
      setStep((prevStep) => prevStep + 1);
    } else {
      setTouched(
        relevantFields[step].reduce((acc, field) => {
          acc[field] = true;
          return acc;
        }, {})
      );
    }
  };

  const userEmail = useSelector((state) => state.auth.user?.email);

  const uploadToSheet = async (values) => {
    const formData = new FormData();
    formData.append("name", values.fullName);
    formData.append("email", values.email);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("age", values.age);
    formData.append("height", values.height);
    formData.append("weight", values.weight);
    formData.append("goal", values.goal);
    formData.append("diet", values.diet);
    formData.append("foodPreference", values.foodPreference);
    formData.append(
      "plan",
      Array.isArray(values.plan) ? values.plan.join(",") : values.plan
    );

    formData.append("subscriptionType", values.subscriptionType);
    formData.append("subscriptionStartDate", values.subscriptionStartDate);
    formData.append("physicalState", values.physicalState);

    try {
      const googleResponse = await axios.post(
        "https://script.google.com/macros/s/AKfycbzHe0OBiIvqXpH3YC7V5Wv-dMkrGaaCCk3Smd7tdS9jJhr--Y8NABjODXYCFfD479MV/exec",
        formData
      );
      console.log("Google Sheets update successful");
    } catch (error) {
      console.error("Error posting to Google Sheets:", error.message || error);
    }
  };

  return (
    <div className="formbox " id="formnavhref">
      <div className="flex stepmanager">
        {steps.map((stepName, i) => {
          const isActive = step === i + 1;
          const isComplete = i < step || complete;

          const bgColor = isActive
            ? "stepActive"
            : isComplete
            ? "stepComplete"
            : "pending";

          return (
            <div
              key={i}
              className={`step-item ${isActive ? "active" : ""} ${
                isComplete ? "complete" : ""
              }`}
            >
              <div className={`step ${bgColor}`}>{stepIcons[i]}</div>
              <p className="stepname">{stepName}</p>
            </div>
          );
        })}
      </div>

      <Formik
        initialValues={{
          fullName: "",
          phoneNumber: "",
          email: userEmail,
          age: "",
          gender: "",
          height: 170,
          weight: 70,
          goal: "",
          physicalState: "",
          diet: "",
          foodPreference: "",
          plan: [],
          subscriptionType: "",
          subscriptionStartDate: "",
        }}
        validationSchema={validationSchemas[step - 1]}
        aler
        onSubmit={async (values) => {
          setformBtntext("checking out....");
          await Promise.all([
            uploadToSheet(values),
            navigate("/subscription/checkout", { state: values }),

          ]);
        }}
      >
        {({ values, validateForm, setTouched, setFieldValue }) => (
          <Form className="form">
            <div className="formOutlay">
              {step === 1 && (
                <>
                  <h2>Personal Information</h2>
                  <Field
                    name="fullName"
                    placeholder="Full Name"
                    className="textfeild feild"
                  />
                  <ErrorMessage
                    name="fullName"
                    component="div"
                    className="error"
                  />
                  <Field
                    name="phoneNumber"
                    placeholder="Phone Number"
                    className="textfeild feild"
                  />
                  <ErrorMessage
                    name="phoneNumber"
                    component="div"
                    className="error"
                  />
                  <Field
                    name="email"
                    placeholder="Email"
                    className="textfeild feild"
                    readOnly
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error"
                  />
                  <Field
                    name="age"
                    placeholder="Age"
                    className="textfeild feild"
                  />
                  <ErrorMessage name="age" component="div" className="error" />
                </>
              )}

              {step === 2 && (
                <>
                  <h2>Physical Information</h2>
                  <div className="gender-selection">
                    <h3>Choose Gender</h3>
                    <section>
                      <div>
                        <label className="gendercard">
                          <Field
                            type="radio"
                            name="gender"
                            value="male"
                            className="hidden"
                          />
                          <div className="card-content">
                            <img
                              src={male}
                              alt="male"
                              className="h-[40px]"
                              loading="lazy"
                            />
                          </div>
                        </label>
                        <p className="text-black text-[16px] text-center">
                          Male
                        </p>
                      </div>
                      <div>
                        <label className="gendercard">
                          <Field
                            type="radio"
                            name="gender"
                            value="female"
                            className="hidden"
                          />
                          <div className="card-content">
                            <img
                              src={female}
                              alt="female"
                              className="h-[40px]"
                              loading="lazy"
                            />
                          </div>
                        </label>
                        <p className="text-black text-[16px] text-center">
                          Female
                        </p>
                      </div>
                    </section>
                    <ErrorMessage
                      name="gender"
                      component="div"
                      className="error"
                    />
                  </div>

                  <div className="heghtselection">
                    <div className="stutsofheightweight">
                      <h3>Choose Height (cm)</h3>
                      <span className="bubble">{`${values.height} cm`}</span>
                    </div>

                    <Field
                      name="height"
                      as="input"
                      type="range"
                      min="100"
                      max="400"
                      value={values.height}
                      className="slider"
                      onChange={(e) => setFieldValue("height", e.target.value)}
                    />

                    <ErrorMessage
                      name="height"
                      component="div"
                      className="error"
                    />
                  </div>

                  <div className="heghtselection">
                    <div className="stutsofheightweight">
                      <h3>Choose Weight (kg)</h3>
                      <span className="bubble">{`${values.weight} kg`}</span>
                    </div>
                    <Field
                      name="weight"
                      as="input"
                      type="range"
                      min="30"
                      max="200"
                      value={values.weight}
                      className="slider"
                      onChange={(e) => setFieldValue("weight", e.target.value)}
                    />

                    <ErrorMessage
                      name="weight"
                      component="div"
                      className="error"
                    />
                  </div>
                </>
              )}

              {step === 3 && (
                <>
                  <h2>Goals</h2>
                  <div className="gender-selection">
                    <h3>Choose Your Goal</h3>

                    <section>
                      <div>
                        <label className="gendercard">
                          <Field
                            type="radio"
                            name="goal"
                            value="Weight Loss"
                            className="hidden"
                          />
                          <div className="card-content">
                            <img
                              src={weightLoss}
                              alt="weightLoss"
                              className="h-[40px]"
                              loading="lazy"
                            />
                          </div>
                        </label>
                        <p className="text-black text-[16px] text-center">
                          Weight Loss
                        </p>
                      </div>

                      <div>
                        <label className="gendercard">
                          <Field
                            type="radio"
                            name="goal"
                            value="Balanced Weight"
                            className="hidden"
                          />
                          <div className="card-content">
                            <img
                              src={balancedWeight}
                              alt="Balanced Weight"
                              className="h-[40px]"
                              loading="lazy"
                            />
                          </div>
                        </label>
                        <p className="text-black text-[16px] text-center">
                          Balanced Weight
                        </p>
                      </div>
                      <div>
                        <label className="gendercard">
                          <Field
                            type="radio"
                            name="goal"
                            value="Gain Muscle"
                            className="hidden"
                          />
                          <div className="card-content">
                            <img
                              src={muscle}
                              alt="Gain Muscle"
                              className="h-[40px]"
                              loading="lazy"
                            />
                          </div>
                        </label>
                        <p className="text-black text-[16px] text-center">
                          Gain Muscle
                        </p>
                      </div>
                      <div>
                        <label className="gendercard">
                          <Field
                            type="radio"
                            name="goal"
                            value="Sport Specific Diet"
                            className="hidden"
                          />
                          <div className="card-content">
                            <img
                              src={sport}
                              alt="Sport Specific Diet"
                              className="h-[40px]"
                              loading="lazy"
                            />
                          </div>
                        </label>
                        <p className="text-black text-[16px] text-center">
                          Sport Specific Diet
                        </p>
                      </div>
                    </section>
                    <ErrorMessage
                      name="goal"
                      component="div"
                      className="error"
                    />
                  </div>
                </>
              )}

              {step === 4 && (
                <>
                  <h2>Diet</h2>
                  <div className="gender-selection">
                    <h3>Choose Your Diet</h3>
                    <section>
                      {values.goal === "Weight Loss" ||
                      values.goal === "Balanced Weight" ? (
                        <>
                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="diet"
                              value="Low Carb & High Protein"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={lowcrab}
                                alt="Low Carb & High Protein"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Low Carb &<br /> High Protein
                            </p>
                          </label>

                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="diet"
                              value="Balanced Meal"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={balancedfood}
                                alt="Balanced Meal"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Balanced Meal
                            </p>
                          </label>

                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="diet"
                              value="Ketogenic"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={ketogenic}
                                alt="Ketogenic"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Ketogenic
                            </p>
                          </label>

                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="diet"
                              value="Salads"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={salads}
                                alt="Salads"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Salads
                            </p>
                          </label>
                        </>
                      ) : values.goal === "Gain Muscle" ? (
                        <>
                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="diet"
                              value="High Protein Meals"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={highProtien}
                                alt="High Protein Meals"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              High Protein Meals
                            </p>
                          </label>

                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="diet"
                              value="Salads"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={salads}
                                alt="Salads"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Salads
                            </p>
                          </label>
                        </>
                      ) : values.goal === "Sport Specific Diet" ? (
                        <>
                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="diet"
                              value="Athletic style"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={asthetic}
                                alt="Athletic style"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Athletic style
                            </p>
                          </label>
                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="diet"
                              value="Salads"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={salads}
                                alt="Salads"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Salads
                            </p>
                          </label>
                        </>
                      ) : null}
                    </section>

                    <ErrorMessage
                      name="diet"
                      component="div"
                      className="error"
                    />
                  </div>
                </>
              )}

              {step === 5 && (
                <>
                  <h2>Food Preferences</h2>
                  <div className="gender-selection">
                    <h3>Choose Your Food Type</h3>
                    <section>
                      {(values.goal === "Weight Loss" ||
                        values.goal === "Balanced Weight") && (
                        <>
                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="foodPreference"
                              value="Non Vegetarian"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={nonveg}
                                alt="nonveg"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Non Vegetarian
                            </p>
                          </label>
                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="foodPreference"
                              value="Vegetarian"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={veg}
                                alt="veg"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Vegetarian
                            </p>
                          </label>
                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="foodPreference"
                              value="Eggterian"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={egg}
                                alt="Eggterian"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Eggterian
                            </p>
                          </label>
                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="foodPreference"
                              value="Vegan"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={vegan}
                                alt="vegan"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Vegan
                            </p>
                          </label>
                        </>
                      )}
                      {(values.goal === "Gain Muscle" ||
                        values.goal === "Sport Specific Diet") && (
                        <label className="gendercard">
                          <Field
                            type="radio"
                            name="foodPreference"
                            value="Non Vegetarian"
                            className="hidden"
                          />
                          <div className="card-content">
                            <img
                              src={nonveg}
                              alt="nonveg"
                              className="h-[40px]"
                              loading="lazy"
                            />
                          </div>
                          <p className="text-black text-[16px] text-center">
                            Non Vegetarian
                          </p>
                        </label>
                      )}
                    </section>
                    <ErrorMessage
                      name="foodPreference"
                      component="div"
                      className="error"
                    />
                  </div>
                </>
              )}

              {step === 6 && (
                <>
                  <h2>Physical State</h2>
                  <div className="gender-selection">
                    <h3>Choose Physical State</h3>
                    <section>
                      <label className="gendercard">
                        <Field
                          type="radio"
                          name="physicalState"
                          value="Sedentary"
                          className="hidden"
                        />
                        <div className="card-content">
                          <img
                            src={sadentry}
                            alt="Sedentary"
                            className="h-[40px]"
                            loading="lazy"
                          />
                        </div>
                        <p className="text-black text-[16px] text-center">
                          Sedentary
                        </p>
                      </label>
                      <label className="gendercard">
                        <Field
                          type="radio"
                          name="physicalState"
                          value="Moderately Active"
                          className="hidden"
                        />
                        <div className="card-content">
                          <img
                            src={modarate}
                            alt="Moderately active"
                            className="h-[40px]"
                            loading="lazy"
                          />
                        </div>
                        <p className="text-black text-[16px] text-center">
                          Moderately
                        </p>
                      </label>
                      <label className="gendercard">
                        <Field
                          type="radio"
                          name="physicalState"
                          value="Physically Active"
                          className="hidden"
                        />
                        <div className="card-content">
                          <img
                            src={active}
                            alt="physically active"
                            className="h-[40px]"
                            loading="lazy"
                          />
                        </div>
                        <p className="text-black text-[16px] text-center">
                          Active
                        </p>
                      </label>

                      <label className="gendercard">
                        <Field
                          type="radio"
                          name="physicalState"
                          value="Others"
                          className="hidden"
                        />
                        <div className="card-content">
                          <img
                            src={others}
                            alt="others"
                            className="h-[40px]"
                            loading="lazy"
                          />
                        </div>
                        <p className="text-black text-[16px] text-center">
                          Others
                        </p>
                      </label>
                    </section>
                    <ErrorMessage
                      name="physicalState"
                      component="div"
                      className="error"
                    />
                    <h3>select Subscription type</h3>
                    <section>
                      {/* Conditionally render based on the selected diet */}
                      {values.diet === "Salads" ? (
                        <label className="gendercard">
                          <Field
                            type="radio"
                            name="subscriptionType"
                            value="monthly"
                            className="hidden"
                          />
                          <div className="card-content">
                            <img
                              src={monthly}
                              alt="Monthly"
                              className="h-[40px]"
                              loading="lazy"
                            />
                          </div>
                          <p className="text-black text-[16px] text-center">
                            Monthly
                          </p>
                        </label>
                      ) : (
                        <>
                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="subscriptionType"
                              value="monthly"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={monthly}
                                alt="Monthly"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Monthly
                            </p>
                          </label>

                          <label className="gendercard">
                            <Field
                              type="radio"
                              name="subscriptionType"
                              value="weekly"
                              className="hidden"
                            />
                            <div className="card-content">
                              <img
                                src={weekly}
                                alt="Weekly"
                                className="h-[40px]"
                                loading="lazy"
                              />
                            </div>
                            <p className="text-black text-[16px] text-center">
                              Weekly
                            </p>
                          </label>
                        </>
                      )}
                    </section>
                    <ErrorMessage
                      name="subscriptionType"
                      component="div"
                      className="error"
                    />
                  </div>
                </>
              )}

              {step === 7 && (
                <>
                  <h2>Plan</h2>
                  <div className="gender-selection">
                    <h3>
                      Choose a plan to subscribe{" "}
                      {values.diet === "Salads"
                        ? ""
                        : "(You can select multiple)"}
                    </h3>
                    <section>
                      {/* Breakfast Option */}
                      <label className="gendercard">
                        <Field
                          type={values.diet === "Salads" ? "radio" : "checkbox"}
                          name="plan"
                          value="Break Fast"
                          className="hidden"
                        />
                        <div className="card-content multiselect">
                          <img
                            src={breakfast}
                            alt="Breakfast"
                            className="h-[40px]"
                            loading="lazy"
                          />
                        </div>
                        <p className="text-black text-[16px] text-center">
                          Breakfast
                        </p>
                      </label>

                      {/* Lunch Option */}
                      <label className="gendercard">
                        <Field
                          type={values.diet === "Salads" ? "radio" : "checkbox"}
                          name="plan"
                          value="Lunch"
                          className="hidden"
                        />
                        <div className="card-content multiselect">
                          <img
                            src={lunch}
                            alt="Lunch"
                            className="h-[40px]"
                            loading="lazy"
                          />
                        </div>
                        <p className="text-black text-[16px] text-center">
                          Lunch
                        </p>
                      </label>

                      {/* Dinner Option */}
                      <label className="gendercard">
                        <Field
                          type={values.diet === "Salads" ? "radio" : "checkbox"}
                          name="plan"
                          value="Dinner"
                          className="hidden"
                        />
                        <div className="card-content multiselect">
                          <img
                            src={dinner}
                            alt="Dinner"
                            className="h-[40px]"
                            loading="lazy"
                          />
                        </div>
                        <p className="text-black text-[16px] text-center">
                          Dinner
                        </p>
                      </label>
                    </section>
                    {/* Plan Error Message */}
                    <ErrorMessage
                      name="plan"
                      component="div"
                      className="error"
                    />

                    <h3>Select subscription start date</h3>
                    <section>
                      <Field
                        type="date"
                        name="subscriptionStartDate"
                        className="datefeild"
                        min={
                          new Date(new Date().setDate(new Date().getDate() + 3))
                            .toISOString()
                            .split("T")[0]
                        } // Blocks today's date and next two days
                      />

                      <small className="text-gray-600 text-[12px]">
                        Select the date when you want to start your
                        subscription.
                      </small>

                      <ErrorMessage
                        name="subscriptionStartDate"
                        component="div"
                        className="error"
                      />
                    </section>
                  </div>
                </>
              )}
            </div>

            <div className="btncontrol">
              {step > 1 && (
                <button
                  type="button"
                  onClick={() => setStep((prevStep) => prevStep - 1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-left"
                  >
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                  </svg>
                  Previous
                </button>
              )}
              {step < 7 ? (
                <button
                  id="rightnext"
                  type="button"
                  onClick={() => nextStep(validateForm, setTouched)}
                >
                  Next
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </button>
              ) : (
                <button id="rightnext" type="submit">
                  {formbtntext}
                </button>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default MultiStepForm;
